import { useContext, useEffect, useRef, useState, useCallback } from "react";
import { SMContext } from "context/smContext";
import IconButtonDelete from "./IconButtonDelete";
import { IconButton, TextField, Tooltip, Typography } from "@mui/material";
import { messageColor } from "actions/screenActions";
import { Add, Minimize, Search, WorkHistory } from "@mui/icons-material";
import ModalSM from "./ModalSM";
import DivInline from "./DivInline";
import moment from "moment";
import Divider10 from "./Divider10";


export default function MultiSnackbarMsg() {
  const [state, dispatch] = useContext(SMContext);
  const { multiSnackbarMsg, multiSnackbarMsgBackup, multiSnackbarMinimized, userObj } = state;
  const [messageHeights, setMessageHeights] = useState({});
  const MARGIN = multiSnackbarMinimized ? 2 : 6;
  const handleHeightChange = useCallback((index, height) => {
    setMessageHeights(prev => ({ ...prev, [index]: height }));
  }, []);

  const calculateBottomOffset = useCallback((index) => {
    return Object.entries(messageHeights)
      .filter(([i]) => parseInt(i) < index)
      .reduce((total, [_, height]) => total + height + MARGIN, 0);
  }, [messageHeights, MARGIN]);

  const handleClearMessages = useCallback(() => {
    dispatch({
      type: "SET_GENERAL_STATE",
      payload: {
        key: "multiSnackbarMsg",
        value: []
      }
    });
  }, [dispatch]);
  if (userObj.level > 2) return null;
  return (
    <>
      <div className="message-container">
        {(multiSnackbarMsg || []).map((msg, key) => (
          <MessageItem
            key={msg.animationKey}
            msg={msg}
            index={key}
            totalItems={multiSnackbarMsg?.length || 0}
            onHeightChange={handleHeightChange}
            sx={{ bottom: `${calculateBottomOffset(key)}px` }}
            minimized={multiSnackbarMinimized}
          />
        ))}
      </div>
      {
        (multiSnackbarMsgBackup || []).length > 0 &&
        <div style={{ position: "absolute", left: "4vw", bottom: 85, zIndex: 1500 }}>
          <MessageLog multiSnackbarMsgBackup={multiSnackbarMsgBackup} />
        </div>
      }
      {
        (multiSnackbarMsg || []).length > 0 &&
        <>
          <div style={{ position: "absolute", left: "4vw", bottom: 50, zIndex: 1500 }}>
            <IconButtonDelete
              size="large"
              color="error"
              onBtnClick={handleClearMessages}
            />
          </div>

          <div style={{ position: "absolute", left: "4vw", bottom: 15, zIndex: 1500 }}>
            <IconButton
              size="large"
              color="error"
              onClick={() => dispatch({ type: "SET_GENERAL_STATE", payload: { key: "multiSnackbarMinimized", value: !multiSnackbarMinimized } })}
            >
              {multiSnackbarMinimized ? <Add /> : <Minimize />}
            </IconButton>
          </div>
        </>
      }


    </>
  );
}

function MessageItem({ msg, index, totalItems, onHeightChange, sx, minimized }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      onHeightChange(index, ref.current.offsetHeight);
    }
  }, [msg.title, index, onHeightChange, minimized]);

  //status: success, error, warning, info
  const opacity = totalItems < 4 ? 1 : 0.4 + (index * 0.2);
  const backgroundColor = messageColor(msg.status, opacity);
  if (minimized) { sx = { ...sx, height: "8px", minWidth: "120px", padding: "0 2px" }; }
  return (
    <div
      ref={ref}
      className={`message-item`}
      style={{
        backgroundColor,
        color: 'white',
        position: 'absolute',
        ...sx
      }}
    >
      {!minimized && <Typography variant="caption">{msg.title}</Typography>}
    </div>
  );
}

function MessageLog({ multiSnackbarMsgBackup }) {
  const [openLog, setOpenLog] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredMessages, setFilteredMessages] = useState(multiSnackbarMsgBackup);

  useEffect(() => {
    if (searchText?.length > 3) {
      setFilteredMessages(multiSnackbarMsgBackup.filter((msg) => msg.title.includes(searchText)));
    } else {
      setFilteredMessages(multiSnackbarMsgBackup);
    }
  }, [searchText, multiSnackbarMsgBackup]);

  return (
    <>
      <Tooltip title="Message Log">
        <IconButton
          size="large"
          onClick={() => setOpenLog(true)}
          color="error"
        >
          <WorkHistory />
        </IconButton>
      </Tooltip>
      <ModalSM
        modalTitle="Message Log"
        open={openLog}
        onClose={() => setOpenLog(false)}
        width="60vw"
        height="80vh"
        titleComponent={
          <DivInline alignItems="center">
            <Search />
            <TextField
              size="small"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search"
            />
            <IconButtonDelete onBtnClick={() => setSearchText("")} />
          </DivInline>
        }
      >
        <Divider10 />
        {
          (filteredMessages || []).sort((a, b) => b.timeStamp - a.timeStamp).map((msg, key) => (
            <DivInline key={key}>
              <div style={{ width: "1vw", height: "1vw", backgroundColor: messageColor(msg.status, 1), marginRight: "1vw" }}></div>
              <Typography sx={{ width: "10vw" }} variant="caption">{moment(msg.timeStamp).format("YYYY-MM-DD HH:mm:ss")}</Typography>
              <Typography variant="body2">{msg.title}</Typography>
            </DivInline>
          ))
        }
      </ModalSM>
    </>
  );
}
